import { GenerateStepRecordingSummaryRequestSchema, GenerateStepRecordingSummaryResponseSchema } from './generate-step-recording-summary.schema';
/**
 * Generate Step Recording Summary Endpoint Contract
 * Synchronously generate AI step summary (name + description) for a
 * pending_finalization recording and persist on the recording.
 */ export const generateStepRecordingSummaryContract = {
    method: 'POST',
    path: '/api/v2/process-step-recording/:id/generate-summary',
    description: 'Synchronously generate AI step summary (name + description) for a pending_finalization recording and persist on the recording.',
    requestSchema: GenerateStepRecordingSummaryRequestSchema,
    responseSchema: GenerateStepRecordingSummaryResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            400: 'Recording is not in pending_finalization',
            401: 'Unauthorized',
            404: 'Step recording not found',
            500: 'AI generation failed'
        }
    }
};

//# sourceMappingURL=generate-step-recording-summary.contract.js.map